export default "__VITE_ASSET__0e34a4cd__"